import { messages } from "../../lib/messages";
import { isAddressRequired, showsFulfillmentChoice } from "./checkoutFields";
import type { Fulfillment } from "./checkoutFields";
import type { Shop } from "../../api/shop";

interface FulfillmentSectionProps {
  shop: Shop;
  fulfillment: Fulfillment;
  onChangeFulfillment(value: Fulfillment): void;
  address: string;
  onChangeAddress(value: string): void;
  pickupPointId: string;
  onChangePickupPointId(value: string): void;
  addressError?: string;
  pickupPointError?: string;
}

/**
 * FulfillmentSection — способ получения и его подробности
 * (docs/07-miniapp-ux.md §2.5). Переключатель показывается только когда
 * доступны оба способа; включён один — молча используется он, без выбора.
 */
export function FulfillmentSection({
  shop,
  fulfillment,
  onChangeFulfillment,
  address,
  onChangeAddress,
  pickupPointId,
  onChangePickupPointId,
  addressError,
  pickupPointError,
}: FulfillmentSectionProps) {
  return (
    <div className="flex flex-col gap-3">
      {showsFulfillmentChoice(shop) ? (
        <div className="flex rounded-card bg-surface p-1">
          <button
            type="button"
            onClick={() => onChangeFulfillment("delivery")}
            className={`flex-1 rounded-card py-2 text-sm ${fulfillment === "delivery" ? "bg-button text-button-text" : "text-text"}`}
          >
            {messages.fulfillmentDelivery}
          </button>
          <button
            type="button"
            onClick={() => onChangeFulfillment("pickup")}
            className={`flex-1 rounded-card py-2 text-sm ${fulfillment === "pickup" ? "bg-button text-button-text" : "text-text"}`}
          >
            {messages.fulfillmentPickup}
          </button>
        </div>
      ) : null}

      {fulfillment === "delivery" ? (
        <div className="flex flex-col gap-1">
          <label htmlFor="checkout-address" className="text-sm text-hint">
            {messages.addressLabel}
          </label>
          <input
            id="checkout-address"
            name="address"
            required={isAddressRequired(shop)}
            value={address}
            onChange={(event) => onChangeAddress(event.target.value)}
            placeholder={messages.addressPlaceholder}
            className="rounded-card bg-surface px-4 py-2 text-text placeholder:text-hint"
          />
          {addressError ? <p className="text-sm text-red-500">{addressError}</p> : null}
        </div>
      ) : (
        <div className="flex flex-col gap-1">
          <label htmlFor="checkout-pickup-point" className="text-sm text-hint">
            {messages.pickupPointLabel}
          </label>
          <select
            id="checkout-pickup-point"
            name="pickup_point_id"
            required
            value={pickupPointId}
            onChange={(event) => onChangePickupPointId(event.target.value)}
            className="rounded-card bg-surface px-4 py-2 text-text"
          >
            <option value="" disabled>
              —
            </option>
            {shop.delivery.pickup_points.map((point) => (
              <option key={point.id} value={point.id}>
                {point.address}
              </option>
            ))}
          </select>
          {pickupPointError ? <p className="text-sm text-red-500">{pickupPointError}</p> : null}
        </div>
      )}
    </div>
  );
}
